import restAPI from "../http-common";
import session from "./session";
import AdApi from "@/services/Api";
import store from "@/store";

class MyGoalApi {
	getFoodWasteCostVsFoodCost() {
		return restAPI({
			method: "get",
			url: "/food-waste-cost-vs-food-cost",
			params: {outlet_id: store.getters["user/activeOutlet"].outlet_id},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setMonthlyFoodCosts(monthlyFoodCosts, baselineCost) {
		const data = {
			monthly_food_costs: monthlyFoodCosts,
			outlet_id: store.getters["user/activeOutlet"].outlet_id
		};
		if (baselineCost !== "")
			data.baseline_cost = baselineCost;

		return restAPI({
			method: "put",
			url: "food-cost",
			data: data,
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	getCurrentlyTrackedItems(tracking) {
		return restAPI({
			method: "get",
			url: "/tracked-labels",
			params: {
				currently_tracked: tracking,
				...AdApi.getQueryParams()
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	getTotalSaved() {
		return restAPI({
			method: "get",
			url: "/saved-waste",
			params: {
				outlet_id: store.getters["user/activeOutlet"].outlet_id,
				types: "TOTAL",
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setMonthlyGoal(request) {
		return restAPI({
			method: "PUT",
			url: "/monthly-goal",
			data: {
				outlet_id: store.getters["user/activeOutlet"].outlet_id,
				month: request.month,
				monthly_goal_percentage: request.percentage
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setItemGoal(request) {
		return restAPI({
			method: "PUT",
			url: "/label-goal",
			data: {
				outlet_id: store.getters["user/activeOutlet"].outlet_id,
				label_id: request.labelId,
				monthly_goal_percentage: request.percentage
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	getTotalGuestSavings() {
		return restAPI({
			method: "get",
			url: "/total-guest-savings",
			params: {outlet_id: store.getters["user/activeOutlet"].outlet_id, },
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	getMonthlySavings() {
		return restAPI({
			method: "get",
			url: "/saved-waste",
			params: {
				types: "MONTHLY_SAVINGS",
				outlet_id: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	availableBaselines() {
		return restAPI({
			method: "get",
			url: "/available-baselines",
			params: {outlet_id: store.getters["user/activeOutlet"].outlet_id},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setBaseline({startDate, endDate}) {
		return restAPI({
			method: "put",
			url: "/baseline",
			data: {
				baseline: {
					start_date: startDate,
					end_date: endDate
				},
				outlet_id: store.getters["user/activeOutlet"].outlet_id
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	setMealsCO2Settings(request) {
		return restAPI({
			method: "POST",
			url: "/meals-co2-settings",
			data: {
				outlet_id: store.getters["user/activeOutlet"].outlet_id,
				meal_weight_gr: request.mealWeightGr,
				co2_eq_per_kg: request.CO2EqPerKg
			},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}

	baselineStats() {
		return restAPI({
			method: "get",
			url: "/baseline-stats",
			params: {outlet_id: store.getters["user/activeOutlet"].outlet_id},
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}
}

export const MyGoalService = new MyGoalApi();
